import { units } from '@ui/css';
import { combineTokens, makeScaleableToken } from '@utils/css';
import { colors } from '../../design-tokens/colors.js';

const closeButtonTokens = combineTokens("--close-button", {
  lineColor: colors.gray.sim65,
  lineLength: [units.px(17), makeScaleableToken],
  lineThickness: [units.px(1.5), makeScaleableToken]
});
const closeButtonCls = "dibc1qn9e8s";

export { closeButtonCls, closeButtonTokens };
import "./util.close-button.style.linaria.module.css";
//# sourceMappingURL=util.close-button.style.js.map
